import { Observable } from 'rxjs'
import { store } from '../../store/store.js'
import axios from 'axios'
require('es6-promise').polyfill()

const BASE = 'https://middleware-demo-prod.aleacontrol.net/AleaOnline'

const api = {
  getUrlForVDogLocalJackpot () {
    return 'https://cloud.aleacontrol.com/media/vDogs/ghr_local_jp_bg.mp4'
  },
  getUrlForVDogSuperJackpot () {
    return 'https://cloud.aleacontrol.com/media/vDogs/ghr_super_jp_bg.mp4'
  },
  getUrlForVSoccerStadiumJackpot () {
    return 'https://cloud.aleacontrol.com/media/vSoccer/vs_stadium-jp-_bg.mp4'
  },
  getUrlForVSoccerChampionsJackpot () {
    return 'https://cloud.aleacontrol.com/media/vSoccer/vs_champions-jp-_bg.mp4'
  },
  getAuth (tokenFromUrl) {
    return Observable.create((observer) => {
      let url = `${BASE}${this.getQueryParams(tokenFromUrl)}`
      axios.get(url).then(
        (response) => {
          // MOVE TO SERVER
          if (response && response.data && response.data.games) {
            store.setLogoUrl(response.data.logoUrl)
            response.data.games.forEach((game) => {
              store.setGameName(game.gameName)
              if (game.gameName === 'VFootball') {
                game.imageAlt = 'virtual soccer'
                game.imageLink = 'https://cloud.aleacontrol.com/media/vDogs/vsoccer.svg'
              } else if (game.gameName === 'VDogs') {
                game.imageAlt = 'grayhound races'
                game.imageLink = 'https://cloud.aleacontrol.com/media/vDogs/grayhound.svg'
              }
            })
          }
          store.setGames(response.data)
          observer.next(response.data)
          observer.complete()
        },
        (response) => {
          observer.error(response)
          observer.complete()
        }
      )
    })
  },
  getQueryParams (tokenFromUrl) {
    return `?${tokenFromUrl}`
  }
}

export default api
